import type { DonationFrequency } from '@/lib/stripe-billing';

/**
 * Resolves donation frequency from a Firestore donation document.
 * Subscription checkouts must show as monthly even when legacy attribution stored one_time.
 */
export function resolveDonationFrequencyFromFirestore(data: Record<string, unknown>): DonationFrequency {
  const attribution =
    typeof data.attribution === 'object' && data.attribution != null
      ? (data.attribution as Record<string, unknown>)
      : {};

  if (data.donationFrequency === 'monthly' || attribution.donationFrequency === 'monthly') {
    return 'monthly';
  }

  if (data.mode === 'subscription') {
    return 'monthly';
  }

  const stripeSubscriptionId = data.stripeSubscriptionId;
  if (typeof stripeSubscriptionId === 'string' && stripeSubscriptionId.trim().length > 0) {
    return 'monthly';
  }

  return 'one_time';
}
